export default "__VITE_ASSET__M$tsXFKL__"